import { render, staticRenderFns } from "./shop-nav.vue?vue&type=template&id=52ed2bff&scoped=true"
import script from "./shop-nav.vue?vue&type=script&lang=js"
export * from "./shop-nav.vue?vue&type=script&lang=js"
import style0 from "./shop-nav.vue?vue&type=style&index=0&id=52ed2bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed2bff",
  null
  
)

export default component.exports